import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { Button, Typography } from '@material-ui/core';

const DocNoFormat = (props: any) => {
  return (
    <DataTypeProvider
      formatterComponent={({ value, row, column }: any) => {
        const { name } = column;
        const id = name === 'docNo' ? row?._id : row?.opId;

        if (!value) return <></>;
        return (
          <Button
            style={{ margin: 0, padding: 0, paddingLeft: 5, paddingRight: 5 }}
            variant="outlined"
            onClick={() => props?.onOpen(id)}
          >
            <Typography variant="caption">{value}</Typography>
          </Button>
        );
      }}
      {...props}
    />
  );
};

export default DocNoFormat;
